import { ref } from 'vue'
import { getPolicy } from '@/service/common/common'
import { reverseTimestamp } from '@/utils/date-format'
import type {
  ElFile,
  UploadFile
} from 'element-plus/lib/el-upload/src/upload.type'
import { ElUpload } from 'element-plus'
import * as md5Lib from 'js-md5' // 导入整个模块

export function useUploadMd5() {
  const uploadRef = ref<InstanceType<typeof ElUpload>>()

  const extraData = ref()
  const files = ref<Array<string>>([])
  const action = ref()
  const filesMap = ref<Map<string, string>>(new Map())
  const proveFile = ref<Map<string, string>>(new Map())
  const records = ref<Array<string>>([])
  const uploadTimeout = ref<any | null>(null)
  const beforeUpload = async (file: UploadFile) => {
    const data = await getPolicy()
    const key =
      data.dir +
      reverseTimestamp() +
      file.name.substring(file.name.lastIndexOf('.'))
    extraData.value = {
      ...data,
      OSSAccessKeyId: data.accessId,
      key
    }
    action.value = data.host
    files.value.push(data.host + '/' + key)
    if (file instanceof File) {
      if (file.type.startsWith('audio')) {
        records.value.push(data.host + '/' + key)
      } else {
        filesMap.value.set(String(file.uid), data.host + '/' + key)
      }
    }
  }
  const md5UploadTimeOut = async (file: UploadFile) => {
    await delay(1000)
  }

  const delay = (ms: number): Promise<void> => {
    return new Promise((resolve) => setTimeout(resolve, ms))
  }

  const md5Upload = async (file: UploadFile) => {
    const data = await getPolicy()

    await calculateMd5(file.raw).then((value) => {
      const key =
        data.dir + value + file.name.substring(file.name.lastIndexOf('.'))
      extraData.value = {
        ...data,
        OSSAccessKeyId: data.accessId,
        key
      }
      action.value = data.host
      console.log(action.value)
      files.value.push(data.host + '/' + key)
      if (file instanceof File) {
        if (file.type.startsWith('audio')) {
          records.value.push(data.host + '/' + key)
        } else {
          filesMap.value.set(String(file.uid), data.host + '/' + key)
        }
      }
    })
  }

  const calculateMd5 = async (file: File): Promise<unknown> => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader()
      reader.onload = function (e) {
        if (this.result) {
          const buffer = this.result as ArrayBuffer
          const array = new Uint8Array(buffer)
          const data = Array.from(array)
          const md5String = (md5Lib as any)(data) as string
          resolve(md5String) // 解析为字符串
        }
      }
      reader.onerror = function (error) {
        reject(error)
      }
      reader.readAsArrayBuffer(file)
    })
  }

  const proveUpload = async (file: UploadFile) => {
    if (file.name != undefined) {
      const data = await getPolicy()
      const key =
        data.dir +
        reverseTimestamp() +
        file.name.substring(file.name.lastIndexOf('.'))
      extraData.value = {
        ...data,
        OSSAccessKeyId: data.accessId,
        key
      }
      action.value = data.host
      files.value.push(data.host + '/' + key)
      if (file instanceof File) {
        proveFile.value.set(String(file.uid), data.host + '/' + key)
      }
    }
  }

  const onSuccess = (response: any) => {
    console.log(response)
  }

  const onExceed = (elFiles: ElFile[]) => {
    uploadRef.value?.clearFiles()
    const file = elFiles[0]
    file.uid = Number(reverseTimestamp())
    files.value = []
    uploadRef.value!.handleStart(file)
    uploadRef.value!.submit()
  }

  return [
    uploadRef,
    extraData,
    files,
    action,
    beforeUpload,
    proveUpload,
    md5Upload,
    md5UploadTimeOut,
    onSuccess,
    onExceed,
    filesMap,
    proveFile,
    records
  ]
}
